import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

export type TrendDirection = "up" | "down" | "neutral";

type TrendIndicatorProps = {
  direction: TrendDirection;
  label: string;
};

const Root = styled("span")(({ theme }: { theme: Theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  fontSize: 12,
  fontWeight: 500,
  '&[data-trend="up"]': {
    color: theme.palette.brand.green,
  },
  '&[data-trend="down"]': {
    color: theme.palette.brand.errorRed,
  },
  '&[data-trend="neutral"]': {
    color: theme.palette.brand.gray400,
  },
}));

const UpIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const DownIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
    <polyline points="17 18 23 18 23 12" />
  </svg>
);

const TrendIndicator: FC<TrendIndicatorProps> = ({ direction, label }) => (
  <Root data-trend={direction}>
    {direction === "up" && <UpIcon />}
    {direction === "down" && <DownIcon />}
    {label}
  </Root>
);

export default TrendIndicator;
